export default __webpack_public_path__ + "static/media/UY.4549bcf7.svg";